var _path, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManifestosIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.86 2.72222V8.86666C11.86 9.70123 12.5365 10.3778 13.3711 10.3778H19M19 10.3778V25.0444C19 25.879 18.3235 26.5556 17.4889 26.5556H3.51111C2.67655 26.5556 2 25.879 2 25.0444V3.51111C2 2.67655 2.67655 2 3.51111 2H13.4319C13.9593 2 14.4485 2.27492 14.7227 2.72537L18.7797 9.38988C18.9238 9.62663 19 9.89845 19 10.1756V10.3778Z",
    stroke: "#001C35",
    strokeOpacity: 0.9,
    strokeWidth: 2.64444
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.77734,
    y1: 15.9288,
    x2: 15.2218,
    y2: 15.9288,
    stroke: "#001C35",
    strokeOpacity: 0.9,
    strokeWidth: 2.36111
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5.77734,
    y1: 20.6515,
    x2: 15.2218,
    y2: 20.6515,
    stroke: "#001C35",
    strokeOpacity: 0.9,
    strokeWidth: 2.36111
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManifestosIcon);
export default __webpack_public_path__ + "static/media/ManifestosIcon.81c7e40b9f77ded9faca47657f6b7c5f.svg";
export { ForwardRef as ReactComponent };